import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import VueQuillEditor from 'vue-quill-editor'

import TestPlugin from './plugins/TestPlugin/'

import VueCookie from 'vue-cookie';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import '@axios'
import VueFacebookPixel from 'vue-facebook-pixel'

/**
 * Timeout/Interval suspended in background tabs
 * https://stackoverflow.com/questions/6032429/chrome-timeouts-interval-suspended-in-background-tabs
 */
import './libs/HackTimer'

Vue.use(VueFacebookPixel)
Vue.analytics.fbq.init('245564050537290')

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueQuillEditor, /* { default global options } */)

Vue.use(VueCookie)

Vue.config.productionTip = false

// Vue Router
import router from './router'
// Vuex Store
import store from './store/store'


Vue.use(TestPlugin, { store, router })

Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
